<template>
<div class="chapter">
<div class="inner_page">
<div class="bg_F48744">
<p class="dedit"><span class="bold">Dedication</span></p>
<p class="dedi"><em class="italic">To my Mom and Mark.</em></p>
</div>
<div class="image_container">
<img alt="images" src="images/img_001-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Dedication.vue?dea50610